import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje} from '../components/mensajes';

import useTable from "../components/useTable"
import Controls from "../components/controls/Controls";

import { Dimmer} from '../components/spinner';

import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import axios from 'axios';


const CatalogoReparador = props => {


    const headCells = [
        { id: 'codigogestor', label: 'CÓDIGO', width: '100px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        { id: 'nombres', label: 'NOMBRE', width: '200px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        { id: 'responsable', label: 'CÉDULA', width: '80px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        { id: 'idgestor', label: 'ID GESTOR', width: '50px', textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', fontSize: "10px", color: "white" },
        //{ id: 'accion', label: '', width: '120px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
    ]
    

    let token = localStorage.getItem('jwtToken');
    let op = require('../../src/modulos/datos');

    const btnCancela = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [activate, setActivate] = useState(false);
    const [values, setValues] = useState({});
    const [itemSelect, setItemSelect] = useState(-1);
    const [activo, setActivo] = useState(true);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.codigogestor.toLowerCase().includes(target.value.toLowerCase())
                            || x.nombres.toLowerCase().includes(target.value.toLowerCase())
                            || x.responsable.toLowerCase().includes(target.value.toLowerCase())
                            || x.idgestor.includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })

    }



    const seleccionarReparadoresTodos = () => {

        let endpoint = `${op.conexion}/api/catalogo/reparadores`;

        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                setActivate(false);

                if (response.data.length > 0) {

                    var gest = []
                    for (let i = 0; i < response.data.length; i++) {
                        gest.push({
                            idgestor: response.data[i].idgestor,
                            responsable: response.data[i].responsable,
                            codigogestor: response.data[i].codigogestor,
                            nombres: response.data[i].nombres,
                        })
                    }
                    setRecords(gest)
                    
                }

            }

        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }


    const blanquear = () => {

        setMostrar(false);
        setTitulo('');
        setMsg('');
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
    }


    const handleCloseMensa = () => {
        setMostrar(false);
            seleccionarReparadoresTodos();
    }


    const cancelar = () => {

        blanquear();
        props.onHideCancelaCat();
    }

    const seleccionarLista = (index) => (event) => {
        blanquear();
        if (props.caja) {
            props.onHideAceptaCat(values[0])
        } else {
            props.onHideAceptaCat(values[0].idgestor, values[0].nombres, values[0].codigogestor, values[0].responsable);

        }

    };

    const seleccionarFila = (index) => (event) => {

        setItemSelect(index);
        setActivo(false);
        var nombres = recordsAfterPagingAndSorting()[index].nombres;
        var idgestor = recordsAfterPagingAndSorting()[index].idgestor;
        var codigogestor = recordsAfterPagingAndSorting()[index].codigogestor;
        var responsable = recordsAfterPagingAndSorting()[index].responsable;

        var datos = [];

        datos.push({
            nombres,
            idgestor,
            codigogestor,
            responsable
        })
        setValues(datos);
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                seleccionarReparadoresTodos()
            }}
        >
            <Modal.Header style={{ backgroundColor: "#019cd5" }}>
                <Modal.Title style={{ color: "#fff" }}>Seleccionar Personas.</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Mensaje titulo={titulo} mensaje={msg}
                    show={mostrar}
                    onHide={handleCloseMensa} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className="col-md-12 m-0">

<div className="input-group input-group-sm mb-3 m-0 col-md-5">
    <input type='text'
        onChange={handleSearch} className="form-control rounded-pill search-input" />
</div>
</div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item.idgestor} style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)}>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "100px" }}>{item.codigogestor}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "200px" }}>{item.nombres}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "80px" }}>{item.responsable}</td>
                                        <td style={{ fontSize: "10px", textAlign: "center", width: "50px" }}>{item.idgestor}</td>
                                        {/*                                         <td align="center" style={{ fontSize: "10px", textAlign: "center", width: "120px", padding: 0, verticalAlign: "middle" }}>
                                            <button style={{ width: "120px" }} onClick={seleccionarComercio(index)} className="btn btn-outline-info"><i className="fas fa-edit">Seleccionar</i> </button>
                                        </td> */}
                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-success rounded-pill" disabled={activo} style={{ margin: "5px" }} onClick={seleccionarLista()}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill col-md-2"><i className="fa"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoReparador;